import { Toaster as SonnerToaster } from 'sonner';

/**
 * Toaster — wrapper de sonner com tokens Aura DS v3.
 *
 * Posicionado no AppShell uma única vez. Use `toast()` de 'sonner' em qualquer lugar.
 *
 * @example
 *   import { toast } from 'sonner';
 *   toast.success('Cliente atualizado');
 *   toast.error('Falha ao salvar', { description: 'Tente novamente em alguns instantes.' });
 */
export function Toaster() {
  return (
    <SonnerToaster
      position="bottom-right"
      duration={4000}
      closeButton
      richColors={false}
      toastOptions={{
        style: {
          background: 'var(--color-surface)',
          border: '1px solid var(--color-border)',
          color: 'var(--color-ink)',
          fontFamily: 'var(--font-sans)',
          fontSize: 'var(--text-sm)',
          borderRadius: 'var(--radius-md)',
          boxShadow: 'var(--shadow-overlay)',
        },
        classNames: {
          success: '!border-success/30',
          error: '!border-error/30',
          warning: '!border-warning/30',
          info: '!border-signal/30',
          title: '!text-ink !font-semibold',
          description: '!text-muted',
        },
      }}
    />
  );
}
